<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <h1 class="titulo mb-3">Relatórios de erros</h1>
        <v-card>
            <v-card-text>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition" color="primary" rounded @click="filter_open = !filter_open">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ rotate90: filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn color="primary" @click="exportarExcel">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        SALVAR RELATÓRIO
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" class="mt-8" v-show="filter_open">
                        <v-row>
                            <v-col cols="12" sm="4">
                                <m-text-field label="Número da proposta:" outlined v-model="filters.numero_proposta" v-input-filter="[$filters.alphanumeric]" />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <m-text-field label="Login usuário:" outlined v-model="filters.id_usuario" v-input-filter="[$filters.email]" />
                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <DateRange :not-after-today-habilitado="true" v-model="filters.dataRange" @filter="filtrar() "
                                           :shortcut="true" label="Data de execução dos Erros" />
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-select id="FieldCategoria" label="Categoria: " outlined menu-props="offsetY" :items="categorias" hide-details v-model="filters.categoria" placeholder="Selecione a categoria" item-text="name" item-value="value" />
                            </v-col>
                        </v-row>
                        <v-row class="justify-end">
                            <v-col cols="6" sm="3">
                                <v-btn color="secondary" block @click="limparFiltro">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" sm="3">
                                <v-btn color="primary" block @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <br />
                <DataTable url="/painel/logs/listar_erros" :headers="headers" @onLoad="itensCarregados" :params="params" item-key="id" :value="logs_selecionados" class="listagem" ref="datatable" :filter="search">
                    <template v-slot:items="{item}">
                        <td>
                            <v-menu v-if="categoriaPermiteAcao(item.categoria)" :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">O que deseja fazer?</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="reenviar(item.id)">
                                        <v-list-item-title>{{ actionTitle(item.categoria) }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td>{{ item.numero_proposta }}</td>
                        <td>{{ item.data }}</td>
                        <td>{{ item.categoria }}</td>
                        <td>{{ item.descricao }}</td>
                        <td>{{ item.usuario }}</td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
        <br />
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import * as Qs from 'qs'
  import { ErrorCategory } from '@/plugins/constants'
  const CATEGORIAS_SEM_ACAO = ['St_VetAlocacaoProposta']
  export default {
    name: 'RelatorioErros',
    data: () => ({
      headers: [{ text: 'Ações ' }, { text: 'Número da proposta', value: 'numero_proposta' }, { text: 'Data', value: 'data' }, { text: 'Categoria', value: 'categoria' }, { text: 'Mensagem de erro', value: 'descricao' }, { text: 'Usuário logado ', value: 'usuario' }],
      custom_filter: {},
      teste: '',
      numero_proposta: 0,
      categoria: '',
      usuario: '',
      data: '',
      editar: false,
      filter_open: false,
      filters: {
        numero_proposta: '',
        dataRange: ['', ''],
        categoria: '',
        id_usuario: ''
      },
      search: {},
      page: 1,
      itemsPerPage: 15,
      items: [],
      logs_selecionados: [],
      totalItems: null,
      show_button: false,
      categorias: ['teste', 'pronto']
    }),
    computed: {
      params () {
        return {
          pagination: {
            rowsPerPage: 15,
            items_grid: 15,
            sortBy: 'tb_log_erros_recebimento_propostas.data',
            descending: true,
            totalItems: 0
          },
          custom_filter: this.customFilter
        }
      }
    },
    mounted () {
      this.getCategorias()
    },
    methods: {
      categoriaPermiteAcao (categoria) {
        return !CATEGORIAS_SEM_ACAO.includes(categoria)
      },
      limpar () {
        this.$refs.filter.reset()
      },
      scrollToTop () {
        window.scrollTo(0, 0)
      },
      limparFiltro () {
        this.$refs.filter.reset()
        this.search = {}
        this.$refs.datatable.reload()
      },
      filtrar () {
        this.page = 1
        if (this.$refs.filter.validate()) {
          this.search = { ...this.filters }
        }
      },
      reenviar (id) {
        this.$http
          .get('/painel/logs/reenviar', { params: { id: id } })
          .then(result => {
            notification('success', result.data.Msg)
            this.$refs.datatable.reload()
          })
          .catch(error => {
            notification('error', error, 'Ocorreu um erro. Por favor, tente novamente.')
          })
      },
      exportarExcel () {
        const filtros = { ...this.filters }
        const headersExport = this.headers
          .filter(h => h.value)
          .map(h => h.value)

        const headersFormatadoExport = this.headers
          .filter(h => h.value)
          .map(h => h.text)

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: 'tb_log_erros_recebimento_propostas.data', descending: true },
          headers: headersExport,
          headers_formatado: headersFormatadoExport
        }, {
          arrayFormat: 'brackets',
          encode: true
        })

        try {
          window.open(`${this.ws}/erro_proposta/exportar?${encoded_params}`)
        } catch (error) {
          notification('error', `${error.response?.data?.error || error.message}`)
        }
      },
      itensCarregados (items) {
        this.items = items
      },
      getCategorias () {
        this.$http.get('/painel/logs/categorias').then(result => {
          this.categorias = result.data.map(item => item.categoria)
        })
      },
      actionTitle (title) {
        switch (title) {
          case ErrorCategory.RECEBIMENTO_PROPOSTA:
            return 'Re-executar operação'
          case ErrorCategory.GERAR_TRANSACAO_CARTAO:
            return 'Consultar status do pagamento'
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.v-btn:not(.v-btn--round).v-size--default.btn-acoes {
    padding: 0;
    min-width: 0;
    width: 48px;
}
.botoes-acao .v-btn {
    flex: 1;
}
.tooltip-ajuda {
    height: 24px;
    position: relative;
    .tooltip-ajuda-text {
        position: absolute;
        background: #fff;
        padding: 5px;
        border: 2px solid var(--primary);
        bottom: 100%;
        right: 0;
        z-index: -1;
        margin-bottom: 0;
        opacity: 0;
        transition: all ease 500ms !important;
    }
    &:hover .tooltip-ajuda-text {
        opacity: 1;
        z-index: 1;
    }
}
.btn-size {
    width: 300px;
    margin-top: 5px;
    margin-bottom: 10px;
}
.theme--light.v-data-table .v-data-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
    margin-right: 15px !important;
}
</style>
